import React from 'react'
import {Container} from './style'

function Loading(props) {
  return (
    <Container className="container">
      <div className="loading" />
    </Container>
  )
}

export default React.memo(Loading)
